exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#diagram2b1-3 #slots .text-spacing{display:flex;flex-direction:column;justify-content:space-between}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/diagrams/2/2b/diagram3/diagram3.scss
// module id = 1011
// module chunks = 0